import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WorkingStats } from '@app/client/monitor/monitor.models';
import { ApiService } from '@app/core/api/api.service';
import { valueToCamelCase } from '@app/core/utilities/string.utilities';
import { shareRef } from '@app/shared/operators/share-ref.operator';
import { environment } from '@env/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LoggingService } from '../services/error-logging.service';
import { convertMicrostoNumbers } from '../services/metrics-calculations.service';

@Injectable()
export class MonitorAPI {
  constructor(
    private http: HttpClient,
    private logger: LoggingService,
    private api: ApiService,
  ) {}
  public getPerformance(customerId: number, query = '') {
    return this.http.get(`${environment.app.resources.dashboard}customers/${customerId}/performance?${query}`, {}).pipe(
      map(({ data }: any) => convertMicrostoNumbers(data)),
      catchError((error: any) => {
        this.logger.logError('Failed to cust perf', error, 'error');
        return throwError('Failed to cust perf');
      }),
      shareRef(),
    );
  }
  public getWorkingStats(customerId: number, query = ''): Observable<WorkingStats> {
    return this.http
      .get(`${environment.app.resources.dashboard}preview/customers/${customerId}/optimization-stats?${query}`, {})
      .pipe(
        map((response: any) => valueToCamelCase(response.data)),
        catchError((error: any) => {
          this.logger.logError('Failed to top accounts', error, 'error');
          return of({} as WorkingStats);
        }),
      );
  }
}
